import { Inject } from 'inversify-props'
import type { WebhookServiceAdapter } from './adapter'

export class DeleteWebhookUseCase {
	@Inject('WebhookServiceAdapter')
	private webhookService!: WebhookServiceAdapter

	delete = async (id: string): Promise<void> =>
		await this.webhookService.delete(id)
}
